import usePPVConfig from '../../../hooks/usePPVConfig';
import { usePPVEvents } from '../../../hooks/usePPVEvents';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { IStore } from '../../../interfaces/StoreTypes';
import { fetchUserChannelsList } from '../../../store/reducers/liveTvSlice';
import { usePromotions } from './useMainPromotions';

const useGetReadyPromotions = (carousel) => {
    const dispatch = useDispatch();
    const { channels } = useSelector((state: IStore) => state.liveTv.userChannels) ?? [];
    const { data: ppvEventConfig } = usePPVEvents();
    const { refetchPPVConfig } = usePPVConfig();
    const { promotions: promotionsConfig } = useConfigurationSections();

    const { modifiedPromotions, isLoading, isError, isSuccess, isFetching } = usePromotions(carousel);

    const promotions = useMemo(() => {
        if (!modifiedPromotions?.length) {
            return [];
        }

        const promotionConfigTypes = promotionsConfig?.types;
        if (!promotionsConfig || !Array.isArray(promotionConfigTypes)) {
            return modifiedPromotions;
        }

        if (promotionConfigTypes.length === 0) {
            return [];
        }

        return modifiedPromotions.filter((item) => promotionConfigTypes.includes(item.promoType));
    }, [modifiedPromotions, promotionsConfig]);

    useEffect(() => {
        if (!channels || channels.length === 0) {
            dispatch(fetchUserChannelsList(null));
        }

        if (!ppvEventConfig) {
            refetchPPVConfig();
        }
    }, [promotions]);

    return { promotions, isLoading, isError, isSuccess, isFetching };
};

export default useGetReadyPromotions;
